export function DocumentSearchIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M9.99992 9.33333C9.99992 10.4379 9.10449 11.3333 7.99992 11.3333C7.44763 11.3333 6.94763 11.1095 6.58571 10.7475C6.22378 10.3856 5.99992 9.88562 5.99992 9.33333C5.99992 8.22876 6.89535 7.33333 7.99992 7.33333C9.10449 7.33333 9.99992 8.22876 9.99992 9.33333Z'
        fill='white'
      />
      <path
        d='M6.66659 14H11.3333C12.0696 14 12.6666 13.403 12.6666 12.6667V6.27614C12.6666 6.09933 12.5963 5.92976 12.4713 5.80474L8.86185 2.19526C8.73682 2.07024 8.56725 2 8.39044 2H4.66659C3.93021 2 3.33325 2.59695 3.33325 3.33333V10.6667M3.33325 14L6.58571 10.7475M6.58571 10.7475C6.94763 11.1095 7.44763 11.3333 7.99992 11.3333C9.10449 11.3333 9.99992 10.4379 9.99992 9.33333C9.99992 8.22876 9.10449 7.33333 7.99992 7.33333C6.89535 7.33333 5.99992 8.22876 5.99992 9.33333C5.99992 9.88562 6.22378 10.3856 6.58571 10.7475Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  )
}
